import { MenuOpen } from '@material-ui/icons';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { StyledButton } from './styles';

interface IMenuButtonProps {
}

const menuItems = [
  {
      label: 'Business',
      path: '/system-management/business',
  },
  {
      label: 'Grupos',
      path: '/system-management/groups',
  },
  {
      label: 'Usuários',
      path: '/system-management/users',
  },
  {
      label: 'Auditoria',
      path: '/system-management/audit',
  },
];
    

const MenuButton: React.FC<IMenuButtonProps> = ({}) => {
  const history = useHistory();

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return;
    }

    setOpen(false);
  };

  return (
    <React.Fragment>
      <StyledButton ref={anchorRef} onClick={handleToggle}>
        <MenuOpen />
      </StyledButton>
      
      <Popper
        sx={{
          zIndex: 1,
        }}
        style={{zIndex: 100}}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {menuItems.map((option, index) => (
                    <MenuItem
                      disabled={false}
                      selected={index === selectedIndex}
                      onClick={(_event) => {
                        history.push(option.path)
                        setSelectedIndex(index);
                      }}
                    >
                      {option.label}
                    </MenuItem>                
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  );
}

export default MenuButton;
